import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler.js'

export function getDataHistory({ trackId, region, device, context, startDate, endDate }) {
  return makeRequest(`/account/store-account/app/${trackId}/data-history/${context}?${paramsToQuery({
    startDate,
    endDate,
    region,
    device,
  })}`)
}

/**
 * Returns a summary of the integrated app's sales metrics.
 * @param {string|number} trackId - App's trackId
 * @param {string} startDate - ISO format start date
 * @param {string} endDate - ISO format end date
 * @returns {Promise<any>} Returns a promise that resolves to the result of the onboarding completion.
 */
export function getSalesMetricsSummary({ trackId, startDate, endDate }) {
  const query = paramsToQuery({ startDate, endDate })
  return cacheRequest(`/account/store-account/app/${trackId}/summary?${query}`)
}

export function getRetentionDataHistory({ trackId, startDate, endDate }) {
  return makeRequest(`/account/store-account/app/${trackId}/data-history/retention?${paramsToQuery({
    startDate,
    endDate,
  })}`)
}
